import { AxiosError } from "axios";
import { api } from "../../api/api";
import Page from "../../model/page/Page";
import Pageable from "../../model/page/Pageable";
import BuscaDetalhada from "../../model/BuscaDetalhada";
import SaldoDevedorResult from "../../model/sienge/saldoDevedor/SaldoDevedorResult";
import InformeImpostoRendaResult from "../../model/sienge/informeImpostoRenda/InformeImpostoRendaResult";
import SaldoDevedorResponse from "../../model/sienge/saldoDevedor/SaldoDevedorResponse";

export default class ExtratoService {

    pesquisar() {
        return new Promise<BuscaDetalhada>((resolve, reject): void => {
            let url = `/extrato`;

            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    buscarSaldoDevedor() {
        return new Promise<SaldoDevedorResponse>((resolve, reject): void => {
            let url = `/extrato/saldoDevedor`;
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        })
    }

    buscarInformeImpostoRenda(ano: number) {
        return new Promise<InformeImpostoRendaResult>((resolve, reject): void => {
            let url = `/extrato/informeImpostoRenda/${ano}`;
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        })
    }
}